import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  holdToken: null,
  expiresAt: null,
  expiresInSeconds: null,
};

const slice = createSlice({
  name: 'seatsIO',
  initialState: initialState,
  reducers: {
    setSeatsIO: (state, { payload }) => payload,
    setHoldToken: (state, { payload }) => ({
      ...state,
      holdToken: payload,
    }),
    setExpiresAt: (state, { payload }) => ({
      ...state,
      expiresAt: payload,
    }),
    setExpiresInSeconds: (state, { payload }) => ({
      ...state,
      expiresInSeconds: payload,
    }),
    restore: () => initialState,
  },
});

export const {
  setSeatsIO,
  setHoldToken,
  setExpiresAt,
  setExpiresInSeconds,
  restore,
} = slice.actions;

export default slice.reducer;
